// Referral attribution (migration 085). A referral link looks like
//   sellyourlinkedin.com/?ref=<code>
// We capture the code on first paint (mirrors metaAttribution.js), persist it
// in localStorage and fire a best-effort "click" beacon to takeover-api.
// B-REFERRAL-DURABLE (2026-06-02): localStorage (not sessionStorage) so the
// code survives reloads, NEW TABS, and same-browser restarts after a failed
// session — matching the durability class of `idempotencyKey`. Without this a
// seller who failed-then-restarted (or reopened the tab) lost their referral
// attribution; cross-device is handled separately by identity matching. The code then rides along in the
// session-create payload so the backend can attribute the takeover to the
// referrer. Organic / direct-traffic sessions have no ?ref and stay null —
// which is fine, attribution is purely additive.

const STORAGE_KEY = 'takeover.referralCode';

/**
 * Read ?ref=<code> off the URL, persist to localStorage, and return it.
 * Idempotent within a page load. A fresh ?ref always wins over stale storage.
 */
export function captureReferralCode() {
  if (typeof window === 'undefined') return null;
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get('ref');
    const code = raw && /^[A-Za-z0-9]{1,16}$/.test(raw.trim()) ? raw.trim() : null;
    if (code) {
      localStorage.setItem(STORAGE_KEY, code);
      return code;
    }
    return readStoredReferralCode();
  } catch {
    return null;
  }
}

export function readStoredReferralCode() {
  if (typeof window === 'undefined') return null;
  try {
    return localStorage.getItem(STORAGE_KEY) || null;
  } catch {
    return null;
  }
}
